import { SourceType } from 'api-models'
import { Clock as RiTimeLine } from 'components/icons'
import { Monitor01 as RiComputerLine, MarkerPin01 as RiMapPin5Line, Mouse as RiMouseLine, User01 as RiUser3Line, Browser as RiWindow2Line } from 'components/icons'
import { RuleTriggerType } from '../../../rule-form/types'

export const Conditions = (props: { trigger: RuleTriggerType, titleClass?: string }) => {
	const { trigger , titleClass} = props

	return (
		<div className="text-sm">
			<span className={`text-t-gray-checkout font-medium ${titleClass}`}>
				WHEN
			</span>
			<div className={`flex flex-col gap-1 mt-1 text-t-secondary ${!titleClass && ' pl-2'}`}>
				{trigger.max_ad_clicks !== undefined && (
					<ClicksCount max_ad_clicks={trigger.max_ad_clicks} />
				)}
				{trigger.period_value && (
					<Period value={trigger.period_value} type={trigger.period_type} />
				)}
				{trigger.focus && <Focus focus={trigger.focus} />}
			</div>
		</div>
	)
}

const ClicksCount = (props: { max_ad_clicks: number }) => {
	const { max_ad_clicks } = props

	return (
		<div className="flex items-center">
			<RiMouseLine className="h-4 w-4 mr-1 text-t-dark-blue" />
			<span className="text-t-checkbox-unactive">There are</span>
			<strong className="text-bold text-t-checkbox-unactive ml-0.5">
				more than {max_ad_clicks} clicks
			</strong>
		</div>
	)
}

const Period = (props: { value: number; type: string }) => {
	const { value, type } = props

	return (
		<div className="flex items-center">
			<RiTimeLine className="h-4 w-4 mr-1 text-t-dark-blue" />
			Within
			<strong className="text-bold ml-0.5">
				{value} {type}
				{value != 1 && 's'}
			</strong>
		</div>
	)
}

const Focus = (props: { focus: RuleTriggerType['focus'] }) => {
	const { focus } = props

	let Icon
	let title = ''

	if (focus === SourceType.IP) {
		Icon = <RiMapPin5Line className="h-4 w-4 text-t-dark-blue" />
		title = 'IP address'
	}
	if (focus === SourceType.RANGE) {
		Icon = <RiMapPin5Line className="h-4 w-4 text-t-dark-blue" />
		title = 'IP range'
	}
	if (focus === SourceType.DEVICE) {
		Icon = <RiComputerLine className="h-4 w-4 text-t-dark-blue" />
		title = 'Device'
	}
	if (focus === SourceType.PLACEMENT) {
		Icon = <RiWindow2Line className="h-4 w-4 text-t-dark-blue" />
		title = 'Placement'
	}
	if (focus === SourceType.VISITOR) {
		Icon = <RiUser3Line className="h-4 w-4 text-t-dark-blue" />
		title = 'Visitor'
	}

	return (
		<div className="flex items-center gap-1 text-t-checkbox-unactive">
			{Icon} From the same
			<strong className="font-bold">{title}</strong>
		</div>
	)
}
